import { useState, useEffect } from 'react';
import styles from '../../../../../../ApplicationMaintenance.module.scss';
import ApiErrors from '../../../../../../components/NewApplication/ApiErrors';
import Modal from '@mui/material/Modal';
import Base from '../../../../../../../Base/Base';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import Spinner from '../../../../../../../../components/UI/Spinner/Spinner';
import Section from '../../../../../../components/NewApplication/Section';
import { AppExtension } from '../../../../../../../../Classes/ResponseModels/ApplicationManagement/AppManagementModel';
import AppExtensionRequest from '../../../../../../../../Classes/ResponseModels/ApplicationManagement/AppExtensionRequest';
import { APPROVAL_WORKFLOW_TYPES } from '../../../../_constants';
import { CreateAppExtension, CreateApprovalFlow } from '../../../../../../_api';
import AppExtensionForm from './AppExtensionForm';
//app : AppManagementModel
//currentUser: user profile from useIdentify
const AppExtensionCreate = ({
	app,
	currentUser,
	workflowAlreadyExists,
	setWorkflowAlreadyExists,
	appExtensions,
	setAppExtensions,
	disabled,
	requirementNumber,
}) => {
	const [modalOpen, setModalOpen] = useState(false);
	const [apiErrors, setApiErrors] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [appExtension, setAppExtension] = useState(new AppExtension());

	//set default values for newAppExtension
	useEffect(() => {
		let appExt = new AppExtension();
		appExt.appID = app.appMaster.id;
		appExt.order = calculateDefaultOrder();
		setAppExtension(appExt);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleSave = () => {
		let request = new AppExtensionRequest(
			app,
			currentUser,
			APPROVAL_WORKFLOW_TYPES.MultiLevel,
			null,
			appExtensions,
			appExtension,
			requirementNumber
		);

		setIsLoading(true);
		//if workflow doesnt already exist, require window.confirm selection, create approval flow AND THEN update approvers, if it does already exist, do not display window.confirm and only update approvers.
		if (
			!workflowAlreadyExists &&
			window.confirm(
				'This will create the required entries in TS_Event_Matrix table for multi level approval work flow. Removal of these records will require manual intervention after insertion. Would you like to continue?'
			)
		) {
			CreateApprovalFlow(request).then(success => {
				if (success) {
					setWorkflowAlreadyExists(true);
					CreateAppExtension(request)
						.then(resp => {
							setAppExtensions(resp.applicationExtensions);
						})
						.then(x => {
							setIsLoading(false);
						});
				}
			});
		} else {
			CreateAppExtension(request)
				.then(resp => {
					setAppExtensions(resp.applicationExtensions);
				})
				.then(x => {
					//reset app extension after successful save
					let appExt = new AppExtension();
					appExt.order = appExtensions?.length + 2;
					setAppExtension(appExt);
					setIsLoading(false);
					setModalOpen(false);
				});
		}
	};

	const handleChange = e => {
		setAppExtension({
			...appExtension,
			[e.target.name]: e.target.value,
		});
	};

	const calculateDefaultOrder = () => {
		let defaultOrder = app?.appExtensions?.length + 1;
		return defaultOrder;
	};

	return (
		<div>
			<div className={styles.controlsContainer}>
				<Button
					id='app_extension_create_modal_open'
					onClick={() => setModalOpen(true)}
					startIcon={<MaterialIcon icon='add' />}
					disabled={disabled}
					variant='outlined'
				>
					Add Approval Level
				</Button>
			</div>
			<Modal
				open={modalOpen}
				onClose={() => {
					setApiErrors([]);
					setModalOpen(false);
				}}
			>
				<div className={styles.Modal}>
					<Base title='Create App Extension'>
						{isLoading ? (
							<Spinner />
						) : (
							<>
								<ApiErrors errors={apiErrors} />
								<div className={styles.controlsContainer}>
									<Button
										onClick={e => {
											handleSave();
										}}
										outlined
										startIcon={<MaterialIcon icon='save' />}
										id='createAppExtension_Save'
										disabled={disabled}
									>
										Save
									</Button>
								</div>

								<Section label='Create App Extension'>
									<AppExtensionForm
										appExtension={appExtension}
										handleChange={handleChange}
										app={app}
										disabled={disabled}
										requirementNumber={requirementNumber}
									/>
								</Section>
								<div className={styles.controlsContainer}>
									<Button
										onClick={e => {
											handleSave();
										}}
										outlined
										startIcon={<MaterialIcon icon='save' />}
										id='createAppExtension_Save2'
									>
										Save
									</Button>
								</div>
							</>
						)}
					</Base>
				</div>
			</Modal>
		</div>
	);
};

export default AppExtensionCreate;
